import { bookSamplePatches, funnelFlow } from 'funnel/src/app/funnel.flow';
import { FunnelFlowConfig } from 'funnel/src/app/flow/flow-config';
import { applyPatches } from 'funnel/src/app/flow/flow-engine';

// The main funnel's screens with book covers, as before the main funnel switched to text demos.
export const applovinFunnelFlow: FunnelFlowConfig = {
  screens: applyPatches(funnelFlow.screens, bookSamplePatches),
};
